import * as React from "react";
import { forwardRef } from "react";
const SvgText = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.49854 3.5V2.5H2.49854V3.5M5.99854 2.5V9.5M5.99854 9.5H4.99854M5.99854 9.5H6.99854", stroke: "#1A2023", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgText);
export { ForwardRef as ReactComponent };
